import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsNaturezaOperacaoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/natureza-operacao');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Natureza Operação');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/natureza-operacao', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Natureza Operação');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/natureza-operacao', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Natureza Operação');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/natureza-operacao/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Natureza Operação');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/natureza-operacao/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Natureza Operação');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/natureza-operacao/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Natureza Operação');
    }
  }
}
